
import './Tree.css'
export default function Tree() {
return (
    <div className="background">
    <div className="tree">
      <div className="crown">
        <div id="leaves-1" className="leaves"></div>
        <div id="leaves-2" className="leaves"></div>
        <div id="leaves-3" className="leaves"></div>
        <div id="leaves-4" className="leaves"></div>
        <div id="leaves-5" className="leaves"></div>
      </div>
      <div className="trunk"></div>
    </div>
  </div>
);
};